<template>
    <section class="list">
        <div class="contract">
            <div class="list-contracts">
                <div class="top-bar" @click="open()">
                    <span class="title">
                        {{title}}
                    </span>
                    <div class="icon" :class="{'rotate': openContent}">
                        <i class="fas fa-caret-down"/>
                    </div>
                </div>
                <div class="list-content scroll-color" :class="{'active-content': openContent}">
                    <slot />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true
		},
		/**
		 * Prop que define se o component de Accordion deve ser
		 * aberto por padrão
		 */
		openned: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	data () {
		return {
			openContent: false
		}
	},
	mounted() {
		if (this.openned) this.open()
	},
	methods: {
		open() {
			this.openContent = !this.openContent
			this.$emit('input')
		},
	}
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>